export interface UserLanguageOption {
  value: string;
  label: string;
}

/**
 * Языки, на которых живут витрина и письма пользователю: тот же набор, что
 * в сиде переводов витрины (siteTranslationSeed). У пользователя хранится
 * код языка строкой, поэтому справочник статический, а не запрос: языки
 * платформы это отдельная сущность с id, здесь она не при чём.
 */
export const userLanguageOptions: UserLanguageOption[] = [
  { value: "en", label: "English" },
  { value: "ru", label: "Русский" },
  { value: "pl", label: "Polski" },
  { value: "pt", label: "Português" },
];
